import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSubject } from '../../../../../../../Redux/slices/certificate';
import TextOffCanvas from '../../../molecules/OffCanvas/TextOffCanvas/TextOffCanvas';

/**
 *
 */
function Subject({ preview }) {
  const subject = useSelector((state) => state.certificate.subject);
  const { text, color, fontSize } = subject;
  const dispatch = useDispatch();

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleSave = (subjectValue) => {
    dispatch(setSubject(subjectValue));
  };

  return (
    <>
      <div
        className={`${preview ? '' : 'c-container'} subject`}
        variant="primary"
        onClick={() => !preview && handleShow()}
        style={{
          fontSize: `${fontSize}px`,
          color: color,
          textAlign: 'center',
          width: 'fit-content',
          marginBottom: '3rem'
        }}>
        {text || 'Click here to set Subject'}
      </div>

      <TextOffCanvas
        title="Subject"
        show={show}
        initialValue={subject}
        handleClose={handleClose}
        handleSave={handleSave}
      />
    </>
  );
}

export default Subject;
